import React, {SetStateAction} from 'react';
import {IDriverRegistration} from "../interface";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import {IBrand} from "../../brand/interface";
import {Card, Col, Row} from "react-bootstrap";
import Select from "react-select";

interface IProps {
    state: IDriverRegistration | null,
    setState: React.Dispatch<SetStateAction<IDriverRegistration | null>>
    brands: IBrand[] | null;
}

const CreateForm = ({state, setState, brands} : IProps) => {
    const {t} = useTranslation();
    const navigate = useNavigate();

    const changeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target;
        setState((prev) => ({ ...prev, [name]: value }) as IDriverRegistration);
    };

    const switchHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, checked } = e.target;

        const oppositeField = name === 'residesInAustria' ? 'residesOutsideAustria' :
            name === 'residesOutsideAustria' ? 'residesInAustria' :
                null;

        setState((prev) => {
            const updatedState = {
                ...prev,
                [name]: checked,
            };

            if (oppositeField) {
                updatedState[oppositeField] = !checked;
            }

            return updatedState as IDriverRegistration;
        });
    };


    const mappedDataBrands = brands?.map((brand) => ({
        label: brand.name,
        value: brand.id,
    })) ?? [];

    const selectedBrandOptions = mappedDataBrands.filter((opt: any) =>
        state?.brands?.includes(opt?.value)
    );

    return (
        <Card>
            <Card.Body>
                <Row>
                    <Col md={6}>
                        <label className="required-field">{t("global.firstName")}</label>
                        <input
                            type="text"
                            name="firstName"
                            className="form-control"
                            required
                            onChange={changeHandler}
                            value={state?.firstName || ""}
                        />
                    </Col>

                    <Col md={6}>
                        <label className="required-field">{t("global.lastName")}</label>
                        <input
                            type="text"
                            name="lastName"
                            className="form-control"
                            required
                            onChange={changeHandler}
                            value={state?.lastName || ""}
                        />
                    </Col>

                    <Col md={6} className="mt-3">
                        <label className="required-field">{t("global.email")}</label>
                        <input
                            type="email"
                            name="email"
                            className="form-control"
                            required
                            onChange={changeHandler}
                            value={state?.email || ""}
                        />
                    </Col>

                    <Col md={6} className="mt-3">
                        <label className="required-field">{t("global.phone")}</label>
                        <input
                            type="tel"
                            name="phone"
                            className="form-control"
                            required
                            onChange={changeHandler}
                            value={state?.phone || ""}
                        />
                    </Col>

                    <Col md={6} className="mt-3">
                        <label className="required-field">{t("driver_registration.yearOfBirth")}</label>
                        <input
                            type="text"
                            name="yearOfBirth"
                            className="form-control"
                            required
                            onChange={changeHandler}
                            value={state?.yearOfBirth || ""}
                        />
                    </Col>

                    <Col md={6} className="mt-3">
                        <label className="required-field">{t("driver_registration.currentCar")}</label>
                        <input
                            type="text"
                            name="currentCar"
                            className="form-control"
                            required
                            onChange={changeHandler}
                            value={state?.currentCar || ""}
                        />
                    </Col>

                    <Col md={6} className="mt-3">
                        <label className="required-field">{t("brand.brand")}</label>
                        <Select
                            isMulti
                            className="react-select-field"
                            options={mappedDataBrands}
                            value={selectedBrandOptions}
                            onChange={(selectedOptions) => {
                                const ids = selectedOptions.map((opt: any) => opt.value);
                                setState((prev) => ({ ...prev, brands: ids }));
                            }}
                        />
                    </Col>

                    {[
                        { name: "active", label: t("global.active") },
                        { name: "prizeDraws", label: t("driver_registration.prizeDraws") },
                        { name: "emailInfo", label: t("driver_registration.emailInfo") },
                        { name: "residesInAustria", label: t("driver_registration.residesInAustria") },
                        { name: "residesOutsideAustria", label: t("driver_registration.residesOutsideAustria") },
                        { name: "classBLicense2Years", label: t("driver_registration.classBLicense2Years") },
                    ].map(({ name, label }) => (
                        <Col md={3} className="mt-3" key={name}>
                            <label className="d-block text-start" htmlFor={name}>
                                {label}
                            </label>
                            <div className="form-check form-switch">
                                <input
                                    className="form-check-input switch-custom"
                                    type="checkbox"
                                    name={name}
                                    checked={!!state?.[name as keyof IDriverRegistration]}
                                    onChange={switchHandler}
                                    role="switch"
                                    id={name}
                                />
                            </div>
                        </Col>
                    ))}
                </Row>

                <div className="col-12 my-2 d-flex justify-content-end">
                    <button
                        className="btn btn-info"
                        type="button"
                        onClick={() => {
                            navigate(-1);
                            setState(null);
                        }}
                    >
                        {t("global.cancel")}
                    </button>
                    <button className="btn btn-primary ms-3" type="submit">
                        {state?.id ? t("global.update") : t("global.create")}
                    </button>
                </div>
            </Card.Body>
        </Card>
    );
};

export default CreateForm;